module.exports = __webpack_public_path__ + "img/card-folded-pencil.3f70acfc.svg";